import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "@/api/endpoints";
import { apiErrorMessage } from "@/api/client";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [note, setNote] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setErr(null);
    setBusy(true);
    try {
      const { message } = await Auth.forgotPassword(email.trim());
      // The response is intentionally generic (never reveals whether the account
      // exists), so we just surface it.
      setNote(message);
    } catch (e) {
      setErr(apiErrorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-md panel p-8">
        <div className="flex items-center gap-3 mb-6">
          <img
            src="/favicon.svg"
            alt="LeadZeppelin"
            width={36}
            height={36}
            className="w-9 h-9 rounded-lg shadow-[0_6px_20px_rgba(94,176,255,0.28)]"
          />
          <div>
            <div className="text-lg font-semibold">LeadZeppelin</div>
            <div className="text-sm text-mut-300">by Techmellon</div>
          </div>
        </div>

        <h1 className="text-xl font-semibold mb-1">Reset your password</h1>
        <p className="text-mut-300 text-md mb-6">
          Enter your email and we'll send you a link to set a new password.
        </p>

        {note ? (
          <div className="mb-4 text-sm text-accent-azure">{note}</div>
        ) : (
          <>
            <label className="label">Email</label>
            <input
              className="input mb-4"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            {err && <div className="mb-3 text-sm text-accent-pink">{err}</div>}

            <button
              type="submit"
              className="btn btn-primary w-full justify-center"
              disabled={busy || !email.trim()}
            >
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </>
        )}

        <div className="mt-5 text-center">
          <button
            type="button"
            className="text-sm text-accent-azure hover:underline"
            onClick={() => nav("/login")}
          >
            Back to sign in
          </button>
        </div>
      </form>
    </div>
  );
}
